<script setup lang="ts">
const props = withDefaults(defineProps<{ filled?: boolean; size?: string; color?: string }>(), {
  filled: false,
  size: undefined,
  color: undefined,
});
</script>

<template>
  <svg
    v-if="filled"
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M17 14a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3h4.38l.06.06 1.5 1.5a1.5 1.5 0 0 0 2.12 0l1.5-1.5.06-.06H17Zm0-1h-4a1.5 1.5 0 0 0-1.5-1.5v-3A1.5 1.5 0 0 0 13 7h4v6ZM7.44 8.06A1.5 1.5 0 0 1 7 7H3v6h4a1.5 1.5 0 0 1 1.5-1.5v-3a1.5 1.5 0 0 1-1.06-.44ZM3 6h4.38l.06-.06 1.5-1.5a1.5 1.5 0 0 1 2.12 0l1.5 1.5.06.06H17a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3Zm8.85 1.35a.5.5 0 0 1-.7 0l-.65-.64v6.58l.65-.64a.5.5 0 0 1 .7.7l-1.5 1.5a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 0 1 .7-.7l.65.64V6.71l-.65.64a.5.5 0 1 1-.7-.7l1.5-1.5c.2-.2.5-.2.7 0l1.5 1.5c.2.2.2.5 0 .7Z"
    />
  </svg>
  <svg
    v-else
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M11.85 7.35a.5.5 0 0 1-.7 0l-.65-.64v6.58l.65-.64a.5.5 0 0 1 .7.7l-1.5 1.5a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 0 1 .7-.7l.65.64V6.71l-.65.64a.5.5 0 1 1-.7-.7l1.5-1.5c.2-.2.5-.2.7 0l1.5 1.5c.2.2.2.5 0 .7ZM14 17a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8Zm2-4h-3c0 .36-.13.72-.38 1H16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2h3.38A1.5 1.5 0 0 1 7 13H4V7h3c0-.36.13-.72.38-1H4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2h-3.38c.25.28.38.64.38 1h3v6Z"
    />
  </svg>
</template>
